<template>
    <div class="main-card">
      <van-row class="sc-card">
        <van-col span="6">
          <van-button class="bt-type" type="primary" block round @click="filterDoctor('')">全部</van-button>
        </van-col>
        <van-col span="6" v-for="type in typelist" :key="type" >
          <van-button class="bt-type" type="primary" block round @click="filterDoctor(type)">{{type}}</van-button>
        </van-col>
      </van-row>

      <div class="dc-items">
        <van-row  v-for="doctorInfo in doctorList" :key="doctorInfo.DOCTOR_ID" @click="appoint(doctorInfo)">
          <div class="dc-item">
            <van-col span="5">
              <div class="dc-image">
                <van-image round fit="fill" :src="'http://huyi-1252763274.cossh.myqcloud.com/' + doctorInfo.DOCTOR_IMG" />
              </div>
            </van-col>
            <van-col span="19">
                <van-col span="6" class="docName">{{ doctorInfo.DOCTOR_NAME }} </van-col>
                <div class="docTech"> {{ doctorInfo.TECHNICAL_NAME }}</div>
                <div class="docTech">{{ doctorInfo.DOMAIN }}</div>
                <div class="docDesc">{{ doctorInfo.INTRODUCTION }}</div>
            </van-col>
          </div>
        </van-row>
      </div>
    </div>
</template>

<script>

import {Toast} from "vant";
import { setLocal} from "@/common/js/utils";
import {customerBussiness, getWxUserInfo} from "@/service/MpServer";

export default {
  components: {
  },

  name: 'CusDocList',
  data() {
    return {
      isWinXinClient: false,
      isLoading: false,
      typelist: [],
      allDoctors: [],
      doctorList: []
    }
  },

  mounted() {
    const app = this;
    // 获取当用微信信息
    getWxUserInfo(function (){
      app.getDoctorList();
    });

    //本地测试临时用
    // setLocal("login_cus_shop", "DP01");
    // setLocal("login_cus_appid", "wx57e5cb2f979d370d");
    // setLocal("login_cus_openid_DP01", "o2x-iwQ1GHa7UpFQDW6rI333XOoo");
    // app.getDoctorList();
  },

  methods: {
    appoint(docInfo){
      this.$router.push({path: '/CusDocDetail', query: {doctorId: docInfo.DOCTOR_ID}})
    },

    getDoctorList() {
      let _this= this;
      let param = { };
      customerBussiness("DOCTOR_TYPE", "getWDOCList", param, function (data) {
        _this.allDoctors= JSON.parse(data).Table;

        let types= [];
        for(let ls of _this.allDoctors){
          let listName= ls.DOCTOR_TYPE_NAME;
          if ((types.indexOf(listName)< 0) && (listName!= "" )){
            types.push(listName);
          }
        }
        _this.typelist= types;
        _this.filterDoctor("");
      });
    },

    filterDoctor(type){
      this.doctorList= [];
      for(let dc of this.allDoctors){
        if ((dc.DOCTOR_TYPE_NAME== type) || (type== "")){
          if (this.doctorList.filter(item=>item.DOCTOR_ID== dc.DOCTOR_ID).length== 0)
            this.doctorList.push(JSON.parse(JSON.stringify(dc)));
        }
      }

      this.doctorList= this.doctorList.sort(function (a, b){return a.WECHAT_SEQ- b.WECHAT_SEQ});
    }
  }
}
</script>

<style lang="less" scoped >
@import '../../common/style/mixin';

body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
  font-size: 14px !important;
}

.bt-type{
  margin: 5px 2px 0px 2px;
  height: 28px;
  line-height: 28px;
}

.sc-card{
  min-height: 40px;
  padding: 10px 0px 10px 0px;
  background: rgba(255,255,255,0.65);

  .sc-field{
    background: rgba(255,255,255,0);
  }
  .sc-key{
    border-radius: 20px;
  }
}

.main-card{
  //padding: 15px;
  height: 120px;
  background-image: linear-gradient(180deg, #01BD5D 0%, rgba(40,216,125,0.00) 100%);
}

.dc-items{
  top: 100px;
  margin-top: 10px;
  background: #FFFFFF;
}

.dc-item{
  margin-bottom: 6px;
  background: #FFFFFF;
  box-shadow: 0 8px 34px 0 rgba(0,0,0,0.08);
  padding: 5px;
  border-bottom: 2px solid #dedede;
  border-radius: 10px;
  border: 2px solid #dedede;
  height: 80px;

  .dc-image{
    margin: 5px 0px 0px 5px;
    width: 55px;
    height: 55px;
  }
  .docName{
    font-size: 18px;
    line-height: 24px;
    color: #333333;
    //font-family: PingFangSC-Regular;
    //color: #333333;
    //letter-spacing: 0;
    //text-align: center;

  }
  .docTech{
    font-size: 15px;
    line-height: 26px;
    color: #999999;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .docDesc{
    line-height: 18px;
    font-size: 14px;
    font-weight: 40;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #999999;
  }
}
</style>
